import { useEffect, useState } from 'react';
import { Box, Button, TextField, Typography, Link as MuiLink, CircularProgress, Alert } from '@mui/material';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { clearErrors, loginUser } from '../../actions/userAction';
import MetaData from '../Layouts/MetaData';
import AuthLayout from './AuthLayout';

const Login = () => {

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const location = useLocation();

    const { loading, isAuthenticated, error } = useSelector((state) => state.user);

    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
  
      const handleLogin = (e) => {
          e.preventDefault();
          dispatch(loginUser(email, password));
      }
  
      const redirect = location.search ? `/${location.search.split("=")[1]}` : "/account";
  
      useEffect(() => {
          if (error) {
              console.error(error);
          }
          if (isAuthenticated) {
              navigate(redirect);
          }
      }, [dispatch, error, isAuthenticated, navigate, redirect]);
  
      return (
          <AuthLayout
              sidebarTitle="Login"
              sidebarTagline="Get access to your Orders, Wishlist and Recommendations"
          >
              <MetaData title="Login - AmritLok" />
              <Typography component="h2" variant="h5" sx={{ mb: 3, fontWeight: 600, textAlign: 'center' }}>
                  Welcome Back!
              </Typography>
              <Box component="form" onSubmit={handleLogin} noValidate sx={{ mt: 1 }}>
                  {error && <Alert severity="error" sx={{ width: '100%', mb: 2 }}>{error}</Alert>}
                  <TextField
                      margin="normal"
                      required
                      fullWidth
                      id="email"
                      label="Email Address"
                      name="email"
                      autoComplete="email"
                      autoFocus
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                  />
                  <TextField
                      margin="normal"
                      required
                      fullWidth
                      name="password"
                      label="Password"
                      type="password"
                      id="password"
                      autoComplete="current-password"
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                  />
                  <Button
                      type="submit"
                      fullWidth
                      variant="contained"
                      sx={{ mt: 3, mb: 2, py: 1.5 }}
                      disabled={loading}
                  >
                      {loading ? <CircularProgress size={24} /> : 'Sign In'}
                  </Button>
                  <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                      <MuiLink component={Link} to="/password/forgot" variant="body2">
                          Forgot password?
                      </MuiLink>
                      <MuiLink component={Link} to="/register" variant="body2">
                          {"Don't have an account? Sign Up"}
                      </MuiLink>
                  </Box>
              </Box>
          </AuthLayout>
      );
  };
  
  export default Login;
